module.exports = "<h4 md-dialog-title class=\"primary\"></h4>\r\n      <!--<md-divider></md-divider>-->\r\n      <md-dialog-content>\r\n      \r\n      </md-dialog-content>\r\n      <md-dialog-actions layout=\"row\" layout-align=\"end center\">\r\n            <button md-button md-dialog-close (click)=\"close()\">Cerrar</button>\r\n            <button md-button md-dialog-close (click)=\"delete()\">Aceptar</button>\r\n      </md-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/toggleConfirmar/toggleconfirmar.component.html
// module id = ./src/app/consulta/toggleConfirmar/toggleconfirmar.component.html
// module chunks = main